export default __webpack_public_path__ + "static/media/jaw-down.6a6eab89.svg";